<template>
  <button
    v-on:click="buttonClick"
    :class="{
      skjerm: nextLayerName === 'Skaermkort',
      orto: nextLayerName === 'Ortho',
      forvaltning: nextLayerName === 'Forvaltning'
    }"
  >
    <!-- <span class='button-text'>{{nextLayerName}}</span> -->
  </button>
</template>

<script>
export default {
  name: 'layer-carousel-button',
  data () {
    return {
      selectedIndex: 0,
    };
  },
  props: {
    map: Object,
    layerNames: Array,
  },
  computed: {
    nextLayerName () {
      const nextIndex = this.selectedIndex === this.layerNames.length - 1 ? 0 : this.selectedIndex + 1;
      return this.layerNames[nextIndex];
    },
    selectedLayerName () {
      console.log(this.layerNames[this.selectedIndex]);
      return this.layerNames[this.selectedIndex];
    },
  },
  methods: {
    buttonClick () {
      this.hideLayers();
      this.selectedIndex++;
      if (this.selectedIndex >= this.layerNames.length) { this.selectedIndex = 0; }
      this.showLayer(this.layerNames[this.selectedIndex]);
    },
    showLayer (layerName) {
      this.getLayer(layerName).setVisible(true);
    },
    hideLayers () {
      this.layerNames.map(layerName => this.getLayer(layerName).setVisible(false));
    },
    getLayer (layerName) {
      return this.map && this.map.getLayers().getArray()
        .find(function (l) {
          return l.get('title') === layerName;
        });
    },
  },
};
</script>

<style scoped>
button{
  position:absolute;
  left:95px;
  bottom:10px;
  z-index:3;
  width: 50px;
  height: 50px;
  cursor: pointer;
  border: none;
  text-decoration: none;
  color: white;
  padding: 0;
  box-shadow: 0 0 8px 0 rgba(175,186,213,0.30);
  background-size: 50px 50px;
}

button:focus {outline:0;}

.skjerm {
  background-image: url(./skjerm.png)
}
.orto {
  background-image: url(./orto.png)
}
.forvaltning {
  background-image: url(./forvaltning.png)
}
</style>
